import React, { Component } from "react";
import { Alert, Checkbox, Col, Modal, Row, Select, Table, Tag, message } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import DatePickerItem from "./DatePickerItem";
import InputNumberItem from "./InputNumberItem";
import SelectItem from "./SelectItem";
import SelectProyectosItem from "./SelectProyectosItem";
import dineroDisabledMask from "./dineroDisabledMask";

moment.locale("es");

const { Option } = Select;

// Modal de cambio de Tipo de Cliente / Tipo de Proveedor.
//
// Los dos casos son el mismo flujo: el tipo decide en que cuenta contable vive el
// saldo de la entidad, asi que cambiarlo obliga a trasladar ese saldo con una poliza
// de reclasificacion o el auxiliar deja de cuadrar contra CxC/CxP. Un solo componente
// parametrizado, porque entre cliente y proveedor solo cambian el endpoint, el nombre
// del campo id y las etiquetas.
const CONFIG = {
  cliente: {
    endpointPrevisualizar: "clientes/previsualizarCambioTipoCliente",
    endpointCambiar: "clientes/cambiarTipoDeCliente",
    campoId: "clienteId",
    etiqueta: "cliente",
    titulo: "Cambiar tipo de cliente",
    etiquetaSaldo: "Cuentas por Cobrar",
  },
  proveedor: {
    endpointPrevisualizar: "proveedores/previsualizarCambioTipoProveedor",
    endpointCambiar: "proveedores/cambiarTipoDeProveedor",
    campoId: "proveedorId",
    etiqueta: "proveedor",
    titulo: "Cambiar tipo de proveedor",
    etiquetaSaldo: "Cuentas por Pagar",
  },
};

const ESTADO_INICIAL = {
  tipoIdNuevo: undefined,
  fecha: null,
  previsualizacion: null,
  montos: {},
  flags: {
    generarCuentaAnticipoId: false,
    generarCuentaFonGarId: false,
    generarCuentaDeudorId: false,
  },
  proyectoId: undefined,
  cargando: false,
  guardando: false,
  confirmado: false,
};

class CambiarTipoEntidadModal extends Component {
  state = { ...ESTADO_INICIAL, fecha: moment() };

  get config() {
    return CONFIG[this.props.entidad];
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ ...ESTADO_INICIAL, fecha: moment() });
    }
  }

  // `resultado` lleva el polizaId para que el padre pueda abrir la poliza recien
  // generada con ModalEditarPoliza.
  cerrar(huboCambio, resultado) {
    this.props.onCerrar(huboCambio, resultado);
  }

  // La previsualizacion depende del tipo, de la fecha (corta el saldo a trasladar) y
  // de los checkboxes (deciden que subcuentas nacen), asi que se vuelve a pedir cada
  // vez que cambia cualquiera de los tres.
  previsualizar(cambios = {}) {
    const siguiente = { ...this.state, ...cambios };
    const { tipoIdNuevo, fecha, flags } = siguiente;

    this.setState({ ...cambios, confirmado: false });

    if (!tipoIdNuevo) {
      this.setState({ previsualizacion: null, montos: {} });
      return;
    }

    this.setState({ cargando: true });
    axios
      .post(
        this.config.endpointPrevisualizar,
        {
          empresaId: this.props.empresaId,
          [this.config.campoId]: this.props.entidadId,
          tipoIdNuevo,
          fecha: fecha ? fecha.format("YYYY-MM-DD") : undefined,
          ...flags,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const montos = {};
          res.data.lineas.forEach((linea) => {
            if (linea.editable) montos[linea.rol] = linea.monto;
          });
          this.setState({ previsualizacion: res.data, montos, cargando: false });
        } else {
          this.setState({ previsualizacion: null, montos: {}, cargando: false });
          message.error(res.data.message || "No se pudo previsualizar el cambio.");
        }
      })
      .catch(() => {
        this.setState({ previsualizacion: null, montos: {}, cargando: false });
        message.error("Error de red al previsualizar el cambio.");
      });
  }

  confirmar() {
    const { tipoIdNuevo, fecha, flags, montos, proyectoId, previsualizacion } = this.state;

    this.setState({ guardando: true });
    axios
      .post(
        this.config.endpointCambiar,
        {
          empresaId: this.props.empresaId,
          [this.config.campoId]: this.props.entidadId,
          tipoIdNuevo,
          fecha: fecha ? fecha.format("YYYY-MM-DD") : undefined,
          proyectoId,
          ...flags,
          lineas: previsualizacion.lineas
            .filter((linea) => linea.editable)
            .map((linea) => ({ rol: linea.rol, monto: montos[linea.rol] || 0 })),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          if (res.data.folioPoliza) {
            message.success(
              `Se cambio el tipo y se genero la poliza de reclasificacion ${res.data.folioPoliza} por ${dineroDisabledMask(res.data.totalTrasladado)}.`
            );
          } else {
            message.success("Se cambio el tipo. No habia saldos que trasladar.");
          }
          this.cerrar(true, res.data);
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo cambiar el tipo.");
        } else {
          message.error(res.data.message || "Hubo un error y el tipo no se cambio.");
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("Error de red al cambiar el tipo.");
      });
  }

  cambiarFlag(campo, valor) {
    this.previsualizar({ flags: { ...this.state.flags, [campo]: valor } });
  }

  columnas() {
    return [
      {
        title: "Cuenta",
        dataIndex: "etiqueta",
        key: "etiqueta",
        width: "18%",
      },
      {
        title: "Actual",
        dataIndex: "cuentaOrigen",
        key: "cuentaOrigen",
        width: "26%",
        render: (cuenta) =>
          cuenta ? cuenta.nombre : <span style={{ color: "#999" }}>Sin cuenta</span>,
      },
      {
        title: "Nueva",
        key: "cuentaDestino",
        width: "26%",
        render: (_, linea) => {
          if (linea.sinCambio) return <Tag>Sin cambio</Tag>;
          if (linea.faltaMayor) {
            return <Tag color="red">El tipo nuevo no tiene esta cuenta</Tag>;
          }
          if (linea.generaCuentaNueva) {
            return (
              <span>
                <Tag color="green">Se generara</Tag>
                {linea.mayorDestino ? (
                  <span style={{ fontSize: 12, color: "#666" }}>
                    bajo {linea.mayorDestino.nombre}
                  </span>
                ) : null}
              </span>
            );
          }
          if (linea.cuentaDestino) return linea.cuentaDestino.nombre;
          // Sin destino y con saldo: el traslado no se puede asentar.
          const monto = linea.editable
            ? this.state.montos[linea.rol] || 0
            : linea.total;
          if (monto) {
            return <Tag color="red">Sin cuenta a donde recibirlo</Tag>;
          }
          return <span style={{ color: "#999" }}>Sin cuenta</span>;
        },
      },
      {
        title: "Origen del saldo",
        dataIndex: "origenMonto",
        key: "origenMonto",
        width: "14%",
        render: (origen) => {
          if (origen === "contable") return <Tag color="blue">Saldo contable</Tag>;
          if (origen === "operativo") {
            return <Tag color="orange">{this.config.etiquetaSaldo}</Tag>;
          }
          if (origen === "no_determinable") {
            return <Tag color="red">No calculable</Tag>;
          }
          return null;
        },
      },
      {
        title: "Saldo a trasladar",
        key: "monto",
        width: "16%",
        align: "right",
        render: (_, linea) => {
          if (!linea.editable) {
            if (!linea.total) return <span style={{ color: "#999" }}>—</span>;
            return (
              <span>
                {dineroDisabledMask(linea.monto)}
                {linea.proyectos > 1 ? (
                  <div style={{ fontSize: 11, color: "#666" }}>
                    {linea.proyectos} proyectos
                  </div>
                ) : null}
              </span>
            );
          }
          return (
            <InputNumberItem
              dinero
              value={this.state.montos[linea.rol]}
              onChange={(valor) =>
                this.setState({
                  montos: { ...this.state.montos, [linea.rol]: valor },
                  confirmado: false,
                })
              }
            />
          );
        },
      },
    ];
  }

  render() {
    const { previsualizacion, cargando, guardando, confirmado } = this.state;
    const config = this.config;

    const lineasEditables = previsualizacion?.lineas.filter((linea) => linea.editable) || [];
    const totalCapturado = lineasEditables.reduce(
      (suma, linea) => suma + Math.abs(this.state.montos[linea.rol] || 0),
      0
    );
    const totalFijo =
      previsualizacion?.lineas
        .filter((linea) => !linea.editable)
        .reduce((suma, linea) => suma + linea.total, 0) || 0;
    const totalATrasladar = totalCapturado + totalFijo;

    // Solo se exige proyecto si el usuario movio alguno de los montos capturables:
    // los saldos calculados aqui ya traen su propio proyecto desde los movimientos.
    const cambioAlgunMonto = lineasEditables.some(
      (linea) => (this.state.montos[linea.rol] || 0) !== linea.monto
    );
    const faltaProyecto =
      cambioAlgunMonto &&
      lineasEditables.some((linea) => (this.state.montos[linea.rol] || 0) !== 0) &&
      !this.state.proyectoId;

    // Un saldo sin cuenta destino no se puede asentar: el backend lo rechaza, asi
    // que el boton se bloquea aqui y se explica arriba.
    const hayCuentaSinConfigurar = !!previsualizacion?.lineas.some((linea) => {
      const monto = linea.editable ? this.state.montos[linea.rol] || 0 : linea.total;
      return monto !== 0 && !linea.cuentaDestino && !linea.generaCuentaNueva;
    });

    const puedeGuardar =
      !!previsualizacion &&
      !cargando &&
      !faltaProyecto &&
      !hayCuentaSinConfigurar &&
      !!this.state.fecha &&
      (totalATrasladar === 0 || confirmado);

    return (
      <Modal
        title={`${config.titulo}${this.props.nombre ? ` — ${this.props.nombre}` : ""}`}
        visible={this.props.visible}
        width={1000}
        onCancel={() => this.cerrar(false)}
        onOk={() => this.confirmar()}
        okText="Cambiar tipo"
        okButtonProps={{ loading: guardando, disabled: !puedeGuardar }}
        cancelText="Cancelar"
        destroyOnClose
      >
        <Row gutter={16}>
          <Col span={12}>
            <div style={{ marginBottom: 4 }}>Tipo nuevo</div>
            <SelectItem
              width="100%"
              placeholder={`Selecciona el tipo de ${config.etiqueta}`}
              value={this.state.tipoIdNuevo}
              onChange={(valor) => this.previsualizar({ tipoIdNuevo: valor })}
            >
              {(this.props.tipos || [])
                .filter((tipo) => tipo._id !== this.props.tipoActualId)
                .map((tipo) => (
                  <Option value={tipo._id} key={tipo._id}>
                    {tipo.nombre + " - " + tipo.descripcion}
                  </Option>
                ))}
            </SelectItem>
          </Col>
          <Col span={12}>
            <div style={{ marginBottom: 4 }}>Fecha de la poliza</div>
            <DatePickerItem
              style={{ width: "100%" }}
              value={this.state.fecha}
              allowClear={false}
              onChange={(fecha) => this.previsualizar({ fecha })}
            />
          </Col>
        </Row>

        {previsualizacion?.tipoNuevo?.generarCuentasAutomatico ? (
          <Row style={{ marginTop: 16 }}>
            <Col span={24}>
              <div style={{ marginBottom: 4 }}>
                Generar tambien estas subcuentas para el {config.etiqueta}
              </div>
              {[
                { campo: "generarCuentaAnticipoId", etiqueta: "Anticipo", rol: "cuentaAnticipoId" },
                { campo: "generarCuentaFonGarId", etiqueta: "Fondo de Garantia", rol: "cuentaFonGarId" },
                { campo: "generarCuentaDeudorId", etiqueta: "Deudor / Acreedor", rol: "cuentaDeudorId" },
              ].map((opcion) => {
                const linea = previsualizacion.lineas.find((l) => l.rol === opcion.rol);
                // Si la entidad ya tiene esa cuenta, se regenera de todos modos para
                // no dejar su saldo varado en el arbol del tipo viejo.
                const forzada = !!linea?.yaTieneCuenta;
                return (
                  <Checkbox
                    key={opcion.campo}
                    style={{ marginRight: 16 }}
                    checked={forzada || this.state.flags[opcion.campo]}
                    disabled={forzada}
                    onChange={(e) => this.cambiarFlag(opcion.campo, e.target.checked)}
                  >
                    {opcion.etiqueta}
                    {forzada ? " (ya la tiene)" : ""}
                  </Checkbox>
                );
              })}
            </Col>
          </Row>
        ) : null}

        {previsualizacion ? (
          <>
            <Table
              style={{ marginTop: 16 }}
              size="small"
              loading={cargando}
              pagination={false}
              dataSource={previsualizacion.lineas}
              columns={this.columnas()}
              rowKey="rol"
              scroll={{ x: true }}
            />

            {previsualizacion.requiereProyecto ? (
              <Row style={{ marginTop: 16 }}>
                <Col span={12}>
                  <div style={{ marginBottom: 4 }}>
                    Proyecto para los montos capturados a mano
                  </div>
                  <SelectProyectosItem
                    width="100%"
                    allowClear
                    placeholder="Selecciona el proyecto"
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    value={this.state.proyectoId}
                    onChange={(valor) => this.setState({ proyectoId: valor })}
                  />
                </Col>
              </Row>
            ) : null}

            {previsualizacion.avisos?.map((aviso, index) => (
              <Alert
                key={index}
                style={{ marginTop: 12 }}
                type="warning"
                showIcon
                message={aviso}
              />
            ))}

            {faltaProyecto ? (
              <Alert
                style={{ marginTop: 12 }}
                type="error"
                showIcon
                message="Selecciona el proyecto al que se cargara la poliza."
              />
            ) : null}

            {hayCuentaSinConfigurar ? (
              <Alert
                style={{ marginTop: 12 }}
                type="error"
                showIcon
                message="Hay saldo por trasladar en una cuenta que el tipo nuevo no puede recibir."
                description="Marca la casilla para generar esa subcuenta, o configura la cuenta en el tipo. Si no, el saldo se quedaria varado en la cuenta actual."
              />
            ) : null}

            {totalATrasladar > 0 ? (
              <>
                <Alert
                  style={{ marginTop: 16 }}
                  type="info"
                  showIcon
                  message={`Se generara una poliza de reclasificacion por ${dineroDisabledMask(
                    totalATrasladar
                  )} con fecha ${this.state.fecha ? this.state.fecha.format("L") : ""}.`}
                  description="El saldo sale de las cuentas actuales y entra a las nuevas. Las cuentas propias de esta entidad quedan en cero, conservando su historico: no se modifican polizas anteriores. Si la fecha cae en un periodo ya declarado, la balanza de ese mes cambiara."
                />
                <Checkbox
                  style={{ marginTop: 12 }}
                  checked={confirmado}
                  onChange={(e) => this.setState({ confirmado: e.target.checked })}
                >
                  Entiendo que se generara una poliza contable con este traslado de saldos
                </Checkbox>
              </>
            ) : (
              <Alert
                style={{ marginTop: 16 }}
                type="success"
                showIcon
                message="No hay saldos que trasladar: solo se cambiara el tipo."
              />
            )}
          </>
        ) : null}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CambiarTipoEntidadModal);
